import type { CapParts } from './termsTable';

/**
 * A quoted cap as the page prints it - each cap with its own label, then "at <price>" - with every part kept whole,
 * so a narrow cell wraps only BETWEEN parts, never inside "8.19% pro forma" (VP8.4 round eight: the picture showed
 * "6.26% pro / forma"). Its text is exactly `capLine` of the same parts, so a copy or a test reads the same line.
 */
export default function CapText({ parts }: { parts: CapParts }) {
  return (
    <>
      {parts.caps.map((c, i) => (
        <span key={i}>
          {i > 0 && ' / '}
          <span className="portal-cap-part">{c}</span>
        </span>
      ))}
      {parts.caps.length > 0 && parts.at && (
        <>
          {' '}
          <span className="portal-cap-part">at {parts.at}</span>
        </>
      )}
    </>
  );
}
